import { retrieveMethod } from "./resource";
const resource = "udprn";
export const retrieve = (client, udprn, request) => retrieveMethod({ resource, client })(udprn, request);
